module.exports = __webpack_public_path__ + "img/ic-id.cd94654b.svg";